module.exports = __webpack_public_path__ + "img/about-intro-1.4040faf8.png";